import { render, staticRenderFns } from "./webgl.vue?vue&type=template&id=19852a9c&"
import script from "./webgl.vue?vue&type=script&lang=js&"
export * from "./webgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports